import React from "react";

export type BadgeTone = "neutral" | "ok" | "warn" | "danger" | "brand";

/**
 * Бейдж DS (canon-session 2026-07-24). Нейтральный фон + маленькая точка-
 * индикатор тона — НИКОГДА заливка+текст одного цвета (распознанный
 * шаблонный анти-паттерн, сознательно избегается).
 */
export function Badge({
  tone = "neutral",
  children,
}: {
  tone?: BadgeTone;
  children: React.ReactNode;
}) {
  const dotCls =
    tone === "ok"
      ? "bg-ok"
      : tone === "warn"
        ? "bg-warn"
        : tone === "danger"
          ? "bg-bad"
          : tone === "brand"
            ? "bg-accent"
            : "bg-fg-muted";

  return (
    <span className="inline-flex items-center gap-[7px] rounded-full bg-bg-elevated text-text-primary text-xs font-semibold pl-2 pr-[11px] py-[5px]">
      {tone !== "neutral" && (
        <span className={`w-[7px] h-[7px] rounded-full shrink-0 ${dotCls}`} />
      )}
      {children}
    </span>
  );
}
